import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { Classbook } from './classbook.model';
import { ClassbookInterface } from './classbook.interface';
import { ClassbookFactory } from './classbook.factory';
import { AuthService } from 'app/shared/auth/auth.service';
import { environment } from 'environments/environment';
import { GlobalService } from 'app/shared/global.service';
import 'rxjs/add/observable/throw';

@Injectable()
export class ClassbookService {

    constructor(private http: HttpClient, private authService: AuthService, private globalService: GlobalService) { }

    getAll(params: HttpParams): Observable<Array<Classbook>> {
        // params = params.append('token', localStorage.getItem('token'));
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<ClassbookInterface[]>(`${environment.apiUrl}/v${environment.apiVersion}/classbooks`, { params, headers: this.authService.headers() })
            .pipe(map(data => data
                .map(item => ClassbookFactory.fromObject(item)),
            ), catchError(this.errorHandler));
    }

    getSingle(id: string, gid: string): Observable<Classbook> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<ClassbookInterface>(`${environment.apiUrl}/v${environment.apiVersion}/classbooks/${id}?gid=${gid}`, { headers: this.authService.headers() })
            .pipe(map(item => ClassbookFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    createOrUpdate(classbook: Classbook): Observable<any> {
        if (classbook.id) {
            return this.http
                // tslint:disable-next-line:max-line-length
                .put(`${environment.apiUrl}/v${environment.apiVersion}/classbooks/${classbook.id}`, classbook, { responseType: 'text', headers: this.authService.headers() })
                .pipe(
                    map(item => JSON.parse(item)),
                    catchError(this.errorHandler)
                );
        }
        return this.http
            // tslint:disable-next-line:max-line-length
            .post(`${environment.apiUrl}/v${environment.apiVersion}/classbooks`, classbook, { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                map(item => JSON.parse(item)),
                catchError(this.errorHandler)
            );
    }



    updateOrder(classbookId: string, items: any[]): Observable<any> {

        return this.http
            // tslint:disable-next-line:max-line-length
            .patch(`${environment.apiUrl}/v${environment.apiVersion}/classbooks`, { items }, { headers: this.authService.headers() })
            .pipe(map(item => ClassbookFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    remove(id: String, gid: String): Observable<any> {
        return this.http
            .delete(`${environment.apiUrl}/v${environment.apiVersion}/classbooks/${id}?gid=${gid}`, { headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    private errorHandler(error: Error | any): Observable<any> {
        // this.globalService.handleError(error);
        console.error('handleError', error)
        return Observable.throw(error);
    }

    /* getAllSearch(searchTerm: string): Observable<Array<Classbook>> {
        return this.http
            .get<ClassbookInterface[]>(`${this.api}/classbooks/search/${searchTerm}`)
            .pipe(
                retry(3),
                map(rawCategories => rawCategories
                    .map(rawClassbook => ClassbookFactory.fromObject(rawClassbook)),
                ),
                catchError(this.errorHandler)
            );
    } */
}



// WEBPACK FOOTER //
// ./src/app/classbook/shared/classbook.service.ts